import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractCustomControl, MakeProvider } from '../../abstract-custom-control';
import { AngularEditorConfig } from '@kolkov/angular-editor';

@Component({
  selector: 'yt-editor',
  templateUrl: './yt-editor.component.html',
    providers: [ MakeProvider(YtEditorComponent)],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class YtEditorComponent extends AbstractCustomControl<any>{
  constructor(protected changeDetectorRef: ChangeDetectorRef){
      super(changeDetectorRef);
  }
  @ViewChild('editorWrapper', { static: false }) editorWrapper: ElementRef;

  @Input() config: AngularEditorConfig;
  @Input() id: string;
  public editorId: string;
  private _internalDisabled = false;

  get disabled(): boolean {
    return this._internalDisabled;
  }

  editorConfig: AngularEditorConfig = {
      editable: true,
      spellcheck: false,
      height: '200px',
      minHeight: '200px',
      maxHeight: 'auto',
      width: 'auto',
      minWidth: '0',
      translate: 'yes',
      enableToolbar: true,
      showToolbar: true,
      placeholder: 'Unesite opis...',
      defaultParagraphSeparator: '',
      defaultFontName: '',
      defaultFontSize: '',
      outline: false,
      fonts: [
        {class: 'arial', name: 'Arial'},
        {class: 'times-new-roman', name: 'Times New Roman'},
        {class: 'calibri', name: 'Calibri'},
        {class: 'comic-sans-ms', name: 'Comic Sans MS'}
      ],
      customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: 'v1/image',
    sanitize: true,
    toolbarPosition: 'top',
    
    toolbarHiddenButtons: [
      [
        'strikeThrough',
        'subscript',
        'superscript',
        'indent',
        'outdent',
        'fontName'
      ],
      [
        'backgroundColor',
        'customClasses',
        'link',
        'unlink',
        'insertImage',
        'insertVideo',
        'insertHorizontalRule',
        'removeFormat',
        'toggleEditorMode'
      ]
    ]
};

ngOnInit() {
  this.editorConfig = {
    ...this.editorConfig,
    ...(this.config || {}),
  };

  this.editorId = this.id || `editor-${Math.random().toString(36).substr(2, 9)}`;
}
  private lastInteractionWasKeyboard = false;

  @HostListener('document:keydown', ['$event'])
  handleKeydown(event: KeyboardEvent) {
    if (event.key === 'Tab') {
      this.lastInteractionWasKeyboard = true;
    }
  }

  @HostListener('document:mousedown')
  handleMousedown() {
    this.lastInteractionWasKeyboard = false;
  }


setDisabledState(isDisabled: boolean){
  super.setDisabledState(isDisabled);
  this._internalDisabled = isDisabled;

  if (isDisabled && this.isEditing) {
    this.cancelEdit();
  }
  this.editorConfig = {
    ...this.editorConfig,
    editable: !isDisabled,
    enableToolbar: !isDisabled,
    showToolbar: !isDisabled
  };

    // Dodavanje/uklanjanje CSS klase za boju teksta
    const editorElement = document.querySelector('.angular-editor-textarea') as HTMLElement;
    if (editorElement) {
      if (isDisabled) {
        editorElement.classList.add('editor-disabled');
      } else {
        editorElement.classList.remove('editor-disabled');
      }
    }
  this.changeDetectorRef.markForCheck();
}

writeValue(value){
  super.writeValue(value);
  this.changeDetectorRef.markForCheck();
}
  isEditing: boolean = false;

  toggleEdit() {
    this.isEditing = true;
    this.changeDetectorRef.detectChanges();

    setTimeout(() => {
      const editable = this.editorWrapper.nativeElement.querySelector('.angular-editor-textarea');
      if (editable) {
        editable.focus();

        if (this.lastInteractionWasKeyboard && this.value && typeof this.value === 'string') {
          this.selectAllEditorContent();
        }

        if (!editable.classList.contains('yt-focus-listener')) {
          editable.addEventListener('focus', (e: FocusEvent) => {
            if (this.lastInteractionWasKeyboard && this.value && typeof this.value === 'string') {
              this.selectAllEditorContent();
            }
          });
          editable.classList.add('yt-focus-listener');
        }

      }
    }, 0);
  }
  private selectAllEditorContent() {
    const editable = this.editorWrapper.nativeElement.querySelector('.angular-editor-textarea');
    if (editable) {
      const range = document.createRange();
      range.selectNodeContents(editable);
      const sel = window.getSelection();
      if (sel) {
        sel.removeAllRanges();
        sel.addRange(range);
      }
    }
  }



  cancelEdit() {
    this.isEditing = false;
    this.changeDetectorRef.markForCheck();
  }

}
